// extracted by mini-css-extract-plugin
export var modalFooter = "_qe-0";